import React from 'react';
import { Link } from 'react-router-dom';
import { Building2, CheckCircle2, Lightbulb, Store, Target, User, Users } from 'lucide-react';
import { useLanguage } from '../i18n/LanguageContext';

export default function AboutPage() {
  const { t } = useLanguage();

  return (
    <section className="section page-top">
      <div className="container narrow">
        <div className="section-head">
          <h1>{t.about.title}</h1>
          <p>{t.about.intro}</p>
        </div>

        <article className="content-panel">
          <h2>{t.about.whyTitle}</h2>
          <p>{t.about.why1}</p>
          <p>{t.about.why2}</p>
          <div className="badge-row">
            {t.about.badges.map((badge) => (
              <span key={badge} className="soft-badge">
                <CheckCircle2 size={14} />
                {badge}
              </span>
            ))}
          </div>
        </article>

        <div className="values-grid">
          <article>
            <Target size={28} />
            <h3>{t.about.missionTitle}</h3>
            <p>{t.about.mission}</p>
          </article>
          <article>
            <Lightbulb size={28} />
            <h3>{t.about.visionTitle}</h3>
            <p>{t.about.vision}</p>
          </article>
          <article>
            <Users size={28} />
            <h3>{t.about.valuesTitle}</h3>
            <p>{t.about.values}</p>
          </article>
        </div>

        <div className="section-head">
          <h2>{t.about.whoTitle}</h2>
        </div>
        <div className="audience-grid">
          <article>
            <Store size={24} />
            <h3>{t.about.shops.title}</h3>
            <p>{t.about.shops.desc}</p>
          </article>
          <article>
            <Building2 size={24} />
            <h3>{t.about.sme.title}</h3>
            <p>{t.about.sme.desc}</p>
          </article>
          <article>
            <User size={24} />
            <h3>{t.about.individuals.title}</h3>
            <p>{t.about.individuals.desc}</p>
          </article>
        </div>

        <div className="page-cta">
          <Link to="/demo" className="btn btn-primary btn-lg">
            {t.nav.demo}
          </Link>
        </div>
      </div>
    </section>
  );
}
